export default __webpack_public_path__ + "static/media/limitedcredit-cat.29eb1b41.svg";